<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    scrollable
    max-width="40rem"
  >
    <template v-slot:activator="{ on: dialog }">
      <v-btn icon text v-on="{ ...dialog }">
        <v-icon>fa-cogs</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="px-1 pt-1">
        <v-row justify="end" no-gutters>
          <v-btn small icon text @click="dialog = false">
            <v-icon small>fa-times</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
      <v-card-text>
        <TillCaisse
          v-bind.sync="caisse"
          :valid.sync="validation.caisseValid"
          :show-info="false"
        ></TillCaisse>
        <v-row dense>
          <v-col cols="12">
            <v-text-field
              filled
              class="no-before"
              dense
              hide-details
              read-only
              label="Total du fond de caisse"
              :value="caisse.total"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row v-show="loading" no-gutters>
          <v-progress-linear indeterminate></v-progress-linear>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-row no-gutters align="center" justify="end">
          <v-btn
            @click="saveDefaultCaisse"
            color="success"
            :disabled="loading"
            :block="$vuetify.breakpoint.xsOnly"
            ><v-icon small left>fa-save</v-icon>Enregistrer</v-btn
          >
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { api } from "@/api";
import TillCaisse from "../components/TillCaisse";
import { mapGetters } from "vuex";
import { round10 } from "round10";
export default {
  name: "TillSettings",
  components: {
    TillCaisse
  },
  computed: {
    ...mapGetters(["getStoreId"])
  },
  data() {
    return {
      loading: true,
      defaultExist: false,
      dialog: false,
      caisse: {
        argent_5cent: 0,
        argent_10cent: 0,
        argent_25cent: 0,
        argent_1dollar: 0,
        argent_2dollar: 0,
        argent_5dollar: 0,
        argent_10dollar: 0,
        argent_20dollar: 0,
        argent_50dollar: 0,
        argent_100dollar: 0,
        rouleaux_5cent: 0,
        rouleaux_10cent: 0,
        rouleaux_25cent: 0,
        rouleaux_1dollar: 0,
        rouleaux_2dollar: 0,
        total: 0
      },
      validation: {
        caisseValid: false
      }
    };
  },
  methods: {
    async getData() {
      try {
        this.loading = true;
        const res = await api.getDefaultFondCaisse();
        if (res && res !== "") {
          this.caisse = res;
          this.caisse.total = this.calculateTotal(this.caisse);
          this.defaultExist = true;
        }
      } finally {
        this.loading = false;
      }
    },
    async saveDefaultCaisse() {
      try {
        this.loading = true;
        if (this.defaultExist === true) {
          await api.patchFondCaisse(this.caisse.id, this.caisse);
        } else {
          const data = {
            ...this.caisse,
            is_default: true,
            store: this.getStoreId
          };
          await api.postFondCaisse(data);
        }
        this.dialog = false;
      } finally {
        this.loading = false;
      }
    },
    calculateTotal(caisse) {
      const total =
        caisse.argent_5cent * 0.05 +
        caisse.argent_10cent * 0.1 +
        caisse.argent_25cent * 0.25 +
        caisse.argent_1dollar * 1 +
        caisse.argent_2dollar * 2 +
        caisse.argent_5dollar * 5 +
        caisse.argent_10dollar * 10 +
        caisse.argent_20dollar * 20 +
        caisse.argent_50dollar * 50 +
        caisse.argent_100dollar * 100 +
        caisse.rouleaux_5cent * 2 +
        caisse.rouleaux_10cent * 5 +
        caisse.rouleaux_25cent * 10 +
        caisse.rouleaux_1dollar * 25 +
        caisse.rouleaux_2dollar * 50;
      return round10(Number(total), -2);
    }
  },
  watch: {
    dialog(v) {
      if (v === true) this.getData();
    }
  }
};
</script>

<style lang="scss" scoped></style>
